/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from 'vue-router'
import { setupLayouts } from 'virtual:generated-layouts'
import { routes } from 'vue-router/auto-routes'
import api from '@/api/client'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts(routes),
})

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (localStorage.getItem('vuetify:dynamic-reload')) {
      console.error('Dynamic import error, reloading page did not fix it', err)
    } else {
      console.log('Reloading page to fix dynamic import error')
      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    }
  } else {
    console.error(err)
  }
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

router.beforeEach(async (to, from, next) => {
  // console.log('Navigating to', to)
  // console.log('Route meta', to.meta)
  if (!to.meta?.requiresAuth) {
    return next()
  }

  try {

    if (window.parent.location.hostname === 'localhost') {
      return next()
    }
    // Backend returns 200 only if cnx-lasso-auth cookie is present and valid
    const i = await api.get('/sso/info')
    if (!i.data) {
      next({ path: '/', query: { next: to.fullPath } })
    }
    next()
  } catch (err) {

  }
})

export default router
